function r(h) {
  let t = 0;
  for (let e = 0; e < h.length; e++)
    t = h.charCodeAt(e) + ((t << 5) - t);
  return `hsl(${t % 360}, 70%, 60%)`;
}
export {
  r as getUserColor
};
